import { Field } from "formik"

function Input({ type, name, placeholder, component, className }) {
    return (
        <Field
            type={type}
            name={name}
            component={component}
            placeholder={placeholder}
            autoComplete="off"
            className={"w-full border border-[#ECECEC] bg-transparent p-4 mt-4 text-base rounded-lg " + className} />
    )
}

export default Input